/* eslint-disable @typescript-eslint/no-explicit-any, no-console */
import _Vue from 'vue'

/**
 * console.logなどのラッパーメソッド
 * .envファイルの設定を参照し、本番環境ではconsole表示しない
 * console.log → this.$logger.log
 */
export default {
  /**
   * plugin登録時に実行される処理
   *
   * @param Vue Vueのコンストラクタ
   */
  install(Vue: typeof _Vue): void {
    /**
     * 設定により処理をスキップして実行しない
     *
     * @param response ログ出力処理
     * @returns responseの値か、何も実行しない空白処理
     */
    const check = function (response: any): any {
      // ログ出力がtrueの場合は引数の処理をそのまま返す
      if (process.env.VUE_APP_DISPLAY_CONSOLE_LOG == 'true') {
        return response
      }

      // ログ出力を実行しない場合、空の処理を返す
      return function () {
        return
      }
    }

    // 各種ログ出力メソッドの定義
    const log = check(console.log.bind(console))
    const info = check(console.info.bind(console))
    const warn = check(console.warn.bind(console))
    const error = check(console.error.bind(console))

    // プロトタイプ登録
    Vue.prototype.$logger = { log, info, warn, error }
  },
}

declare module 'vue/types/vue' {
  /**
   * 呼び出し時のインターフェース定義
   */
  interface Vue {
    /** コンソールへのログ出力 */
    $logger: {
      /** logレベル */
      log: (value: any) => void
      /** infoレベル */
      info: (value: any) => void
      /** warnレベル */
      warn: (value: any) => void
      /** errorレベル */
      error: (value: any) => void
    }
  }
}
